'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _selectors = require('./selectors');

var _Column = require('./Column');

var _Column2 = _interopRequireDefault(_Column);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  {
    "type": "all_jobs",
    "tab": "All Jobs in Banking"
  }

  The footer module for All Jobs.

  All of this data is being passed via the front end,
  so no additional attributes are necessary.
*/

function AllJobs(_ref) {
  var moduleClass = _ref.moduleClass,
      columns = _ref.columns;

  return _react2.default.createElement(
    'div',
    {
      id: 'tab-all-jobs',
      className: 'tab-content type-all_jobs ' + moduleClass
    },
    _react2.default.createElement(
      'div',
      { className: 'columns three-columns' },
      columns.map(function (_ref2, key) {
        var title = _ref2.title,
            _class = _ref2._class,
            jobs = _ref2.jobs;
        return _react2.default.createElement(_Column2.default, {
          key: key,
          title: title,
          _class: _class,
          jobs: jobs
        });
      })
    )
  );
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps, _selectors.mapDispatchToProps)(AllJobs);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/AllJobs/AllJobs.jsx
// module id = 1138
// module chunks = 0